export function updateForm(change) {
  return { type: 'UPDATE_FORM', change }
}

export function increaseFeeQty(fee_name, price) {
  return { type: 'INCREASE_FEE_QTY', fee_name, price }
}

export function decreaseFeeQty(fee_name) {
  return { type: 'DECREASE_FEE_QTY', fee_name }
}

export function updatePaymentDetails(change) {
  return { type: 'UPDATE_PAYMENT_DETAILS', change }
}

export function changeComplimentary(complimentary) {
  return { type: 'CHANGE_COMPLIMENTARY', complimentary }
}

export function updateAccommodationDetails(change) {
  return { type: 'UPDATE_ACCOMMODATION_DETAILS', change }
}

export function finalizeLogin(change) {
  return { type: 'FINALIZE_LOGIN', change }
}

export function finalizeSubmission() {
  return { type: 'FINALIZE_SUBMISSION' }
}


// WEBPACK FOOTER //
// ./src/event_render/actions/index.js